<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss" scoped></style>

<template>
  <div :class="b()">
    <div :class="b('crypto-price')">
      <div class="crypto-price-container">
        <span
          v-if="pair.currency_type_from === 'fiat'"
          :class="[
            b('icon'),
            'fi',
            `fi-${pair.country_from.toLowerCase()}`,
            'flag flag-from',
          ]"
        ></span>
        <img
          class="flag flag-from"
          v-else-if="currencyMap[pair.currency_id_from]"
          :class="b('icon', { crypto: true })"
          :src="
            require(`@/assets/images/crypto/${currencyMap[
              pair.currency_id_from
            ].toLowerCase()}.svg`)
          "
          alt=""
        />

        <span
          v-if="pair.currency_type_to === 'fiat'"
          :class="[
            b('icon'),
            'fi',
            `fi-${pair.country_to.toLowerCase()}`,
            'flag flag-to',
          ]"
        ></span>
        <img
          class="flag flag-to"
          v-else-if="currencyMap[pair.currency_id_to]"
          :class="b('icon', { crypto: true })"
          :src="
            require(`@/assets/images/crypto/${currencyMap[
              pair.currency_id_to
            ].toLowerCase()}.svg`)
          "
          alt=""
        />
      </div>
    </div>
    <div :class="b('info')">
      <div :class="b('header')">
        <div :class="b('pair')">{{ displayedPair }}</div>
      </div>

      <div :class="b('rates')">
        <div :class="b('rate')">
          <span :class="b('label')">{{ $t("Покупка") }}</span>
          <span :class="b('value')">{{ formattedBuyRate }}</span>
        </div>
        <div :class="b('rate')">
          <span :class="b('label')">{{ $t("Продажа") }}</span>
          <span :class="b('value')">{{ formattedSellRate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
